import React from 'react';
import { Form, Input, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { doAdminSignIn } from '../modules/auth/stores/thunk';
import { AuthContainer } from '../modules/auth/containers';
import withUnAuth from './withUnAuth';

import './AdminSignIn.scss';

const AdminSignInPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onLogin = (params) => {
    dispatch(doAdminSignIn(params));
  };

  return (
    <div className="AdminSignInPage">
      <div className="AdminSignInCard">
        <div className="AdminSignInIcon">
          <LockOutlined />
        </div>
        <div className="AdminSignInTitle">Admin Access</div>
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={onLogin}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { type: 'email', message: 'Invalid Email' },
              { required: true, message: 'Required' },
            ]}
          >
            <Input size="large" placeholder="admin@company.com" />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Required' }]}>
            <Input.Password size="large" placeholder="Password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            Sign In
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default AuthContainer(withUnAuth(AdminSignInPage));
